import { z } from "zod";
import { voiceGuesserCandidateSchema } from "./candidate.js";
import { VOICE_GUESSER_MAX_OPTIONS_PER_ROUND, VOICE_GUESSER_MIN_OPTIONS_PER_ROUND, voiceGuesserEffectSchema } from "./game.js";
import { voiceGuesserLeaderboardEntrySchema } from "./leaderboard.js";

export const voiceGuesserRoundSchema = z.object({
	audio_id: z.string(),
	audio_url: z.string(),
	correct_user_id: z.string(),
	effect: voiceGuesserEffectSchema,
	options: z.array(voiceGuesserCandidateSchema).min(VOICE_GUESSER_MIN_OPTIONS_PER_ROUND).max(VOICE_GUESSER_MAX_OPTIONS_PER_ROUND),
});

export type VoiceGuesserRound = z.infer<typeof voiceGuesserRoundSchema>;

export const voiceGuesserPerPlayerRoundResultSchema = z.object({
	user_id: z.string(),
	guessed_user_id: z.string().nullable(),
	answered_at: z.number().nullable(),
	response_time_ms: z.number().int().nonnegative().nullable(),
	is_correct: z.boolean(),
	base_points: z.number().int().nonnegative(),
	speed_bonus: z.number().int().min(0).max(5),
	streak_bonus: z.number().int().nonnegative(),
	points: z.number().int().nonnegative(),
	streak_after: z.number().int().nonnegative(),
});

export type VoiceGuesserPerPlayerRoundResult = z.infer<typeof voiceGuesserPerPlayerRoundResultSchema>;

export const voiceGuesserRankingEntrySchema = voiceGuesserLeaderboardEntrySchema;

export type VoiceGuesserRankingEntry = z.infer<typeof voiceGuesserRankingEntrySchema>;
